<template>
	<div class="container">
		<breadcrumbs
			class="ar"
			:links="[
				{ name: $t('links.home'), link: { name: 'home' } },
				{ name: $t('links.news'), link: {}, active: true },
			]"></breadcrumbs>
		<div class="top">
			<div class="title">{{ $t('links.news') }}</div>
		</div>
		<div>
			<loader v-if="loading" height="35vh" class="mb-4" />
			<div v-else class="main">
				<event-card v-for="newsIndex in news" :key="newsIndex.id" :event="newsIndex"></event-card>
			</div>
		</div>
	</div>
</template>

<script>
import EventCard from '@/components/EventCard';
import Breadcrumbs from '@/components/Breadcrumbs';
import Loader from '@/components/Loader';
import { mapState } from 'vuex';
export default {
	components: {
		EventCard,
		Breadcrumbs,
		Loader,
	},

	data() {
		return {
			eventsCard: [
				{
					title: 'لوريم ايبسوم هو نموذج افتراضي يوضع في التصاميم لتعرض على العميل ليتصور طريقه وضع النصوص بالتصاميم سواء كانت تصاميم مطبوعه ... بروشور او فلاير على سبيل المثال ... او نماذج مواقع انترنت ...',
					date: 'ايلول 22 200',
					img: '/assets/Images/1.jpg',
				},
				{
					title: 'لوريم ايبسوم هو نموذج   ...',
					date: '15 كانون الثاني 2021',
					img: '/assets/Images/2.jpg',
				},
				{
					title: 'لوريم ايبسوم هو نموذج افتراضي يوضع في التصاميم لتعرض على العميل ليتصور طريقه وضع النصوص  ...',
					date: '15 اب 2021',
					img: '/assets/Images/3.jpg',
				},
				{
					title: 'لوريم ايبسوم هو نموذج افتراضي يوضع في التصاميم لتعرض على   ...',
					date: '15 كانون الثاني 2021',
					img: '/assets/Images/4.jpg',
				},
				{
					title: 'لوريم ايبسوم هو نموذج افتراضي يوضع في التصاميم لتعرض على العميل ليتصور طريقه وضع النصوص بالتصاميم سواء كانت تصاميم مطبوعه ... بروشور او فلاير على سبيل المثال ... او نماذج مواقع انترنت ...',
					date: 'ايلول 22 200',
					img: '/assets/Images/1.jpg',
				},
				{
					title: 'لوريم ايبسوم هو نموذج   ...',
					date: '15 كانون الثاني 2021',
					img: '/assets/Images/2.jpg',
				},
				{
					title: 'لوريم ايبسوم هو نموذج افتراضي يوضع في التصاميم لتعرض على العميل ليتصور طريقه وضع النصوص  ...',
					date: '15 اب 2021',
					img: '/assets/Images/3.jpg',
				},
				{
					title: 'لوريم ايبسوم هو نموذج افتراضي يوضع في التصاميم لتعرض على   ...',
					date: '15 كانون الثاني 2021',
					img: '/assets/Images/4.jpg',
				},
				{
					title: 'لوريم ايبسوم هو نموذج افتراضي يوضع في التصاميم لتعرض على العميل ليتصور طريقه وضع النصوص بالتصاميم سواء كانت تصاميم مطبوعه ... بروشور او فلاير على سبيل المثال ... او نماذج مواقع انترنت ...',
					date: 'ايلول 22 200',
					img: '/assets/Images/1.jpg',
				},
				{
					title: 'لوريم ايبسوم هو نموذج   ...',
					date: '15 كانون الثاني 2021',
					img: '/assets/Images/2.jpg',
				},
				{
					title: 'لوريم ايبسوم هو نموذج افتراضي يوضع في التصاميم لتعرض على العميل ليتصور طريقه وضع النصوص  ...',
					date: '15 اب 2021',
					img: '/assets/Images/3.jpg',
				},
				{
					title: 'لوريم ايبسوم هو نموذج افتراضي يوضع في التصاميم لتعرض على   ...',
					date: '15 كانون الثاني 2021',
					img: '/assets/Images/4.jpg',
				},
			],

			loading: true,
		};
	},

	computed: {
		...mapState({
			news: (state) => state.news.news,
		}),
	},

	mounted() {
		this.$store.dispatch('news/fetchAll').finally(() => {
			this.loading = false;
		});
	},
};
</script>

<style scoped>
.container {
	margin-top: 50px;
}
.container > * {
	margin: 0 50px;
}
.main {
	padding: 20px 0 50px;
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(min-content, 333px));
	justify-content: center;
	row-gap: 20px;
	column-gap: 30px;
	margin: auto !important;
}
.main > * {
	max-width: 300px;
	margin: auto;
}
.top {
	text-align: center;
	padding: 10px 0 30px;
	border-bottom: 2px solid var(--borders-color);
}
.top > * {
	padding: 10px;
}
.title {
	font-size: 36px;
	font-family: changeBold;
	color: var(--green-color);
}

@media only screen and (max-width: 992px) {
	.container > div {
		margin: 0 10px;
	}
	.main {
		grid-template-columns: repeat(auto-fit, 250px);
		column-gap: 20px;
	}
}
</style>
